import { ProductShipping } from "@interfaces/dto/product-detail.dto";

interface Props {
  deliveries: ProductShipping[];
}

const DeliveryOptions = ({ deliveries }: Props) => {
  return (
    <>
      {deliveries.map(({ text }, key) => (
        <p key={key}>{text}</p>
      ))}
      {/* <p>
        <i className="icon icon-cash" /> จัดส่งฟรี / เก็บเงินปลายทาง
      </p>
      <p>
        <i className="icon icon-delivery" /> จัดส่งภายใน 1 - 2 วัน
      </p>
      <p>
        เมื่อซื้อ 299.- ขึ้นไป (กรุงเทพฯ ปริมณฑล) และ 799.- ขึ้นไป (ต่างจังหวัด)
      </p> */}
    </>
  );
};

export default DeliveryOptions;
